import Flex from "../../data/Flex";
import UIFlex from "../../ui/UIFlex";
import './DashboardTopBar.scss';

import UITitle from "../../ui/UITitle";
import UIButton, { UIButtonWPopup } from "../../ui/UIButton";
import User from "../../data/User";
import UIIcon from "../../ui/UIIcon";
import Anchor from "../../data/Anchor";
import Color from "../../data/Color";
import { dispatch } from "../../dispatcher/Dispatcher";
import UIEvent from "../../events/UIEvent";


interface IDashboardTopBarProps{
    logout:()=>void;
    userView:()=>void;
    userProfile:()=>void;
}

export interface IUserState{
    PK:string;
    USERNAME:string;
    EMAIL:string;
    PHONE_NUMBER:string;
    USER_ROLE:string;
    PASSWORD?:string;
}


export default function DashboardTopBar($props:IDashboardTopBarProps){


    let cn:string = "dashboardTopBar";

    let popupCloseId:string = "userDropDownPopup";

    const _logout=()=>{
        dispatch(UIEvent.CLOSE_POPUP,popupCloseId);
        $props.logout();
    }

    const _userView=()=>{
        $props.userView();
    }

    const _userProfile=()=>{
        $props.userProfile();
    }
    

    return (
        <UIFlex className={cn} flex={{alignItems:Flex.CENTER}}>
            <UITitle flex={{justifyContent:Flex.CENTER}} className="logo" title={"PSAP Link"}/>
            {(User.state.isAdminUser) && (<UIButtonWPopup 
                hideCloseBtn
                button={
                    {
                        className:"userDropDown", 
                        flex:{direction:Flex.ROW_REVERSE}, 
                        icon:"",
                        label:"Administration",
                        insideChildren:(<UIIcon className="arrowIcon" icon={UIIcon.CHEVRON_DOWN}/>)
                    }} 
                popup={
                    {
                        closeID:popupCloseId,
                        anchor:Anchor.TOP_RIGHT,
                        noPadding:true,
                    }
                }>
                    <UIButton onClick={_userView} icon="" color={Color.WHITE_PRIMARY} label="Users"/>
            </UIButtonWPopup>
            )
            }
            <UIButtonWPopup 
                hideCloseBtn
                button={
                    {
                        className:"userDropDown", 
                        flex:{direction:Flex.ROW_REVERSE}, 
                        icon:UIIcon.USER,
                        label:User.state.loginEmail,
                        insideChildren:(<UIIcon className="arrowIcon" icon={UIIcon.CHEVRON_DOWN}/>)
                    }} 
                popup={
                    {
                        closeID:popupCloseId,
                        anchor:Anchor.TOP_RIGHT,
                        noPadding:false,
                    }
                }>
                    <UIButton onClick={_userProfile} icon={UIIcon.USER_PROFILE} color={Color.WHITE_PRIMARY} label="My Profile" noPadding/>
                    <div className="divider"></div>
                    <UIButton onClick={_logout} icon={UIIcon.LOGOUT} color={Color.WHITE_PRIMARY} label="Logout" noPadding/>
                    
            </UIButtonWPopup>
        </UIFlex>
    );
}